import { useIntl } from '@/intl'
import { useState } from 'react'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    label: translate({ id: 'order.form.bulk.loads.partial.loadNameLabel' }),
    addTooltip: translate({ id: 'order.form.bulk.loads.partial.addTooltip' }),
    fieldDisabled: translate({ id: 'order.form.bulk.loads.fieldDisabled.tooltip' }),
    addTooltipDisabled: (maxLoads: number) =>
      translate({ id: 'order.form.bulk.loads.addLoad.disabled.tooltip', values: { maxLoads } }),
    removeTooltip: translate({ id: 'order.form.bulk.loads.partial.removeTooltip' }),
    title: translate({ id: 'order.form.bulk.loads.partial.sharedLoad.title' }),
  }))

  return api
}
